module.exports = __webpack_public_path__ + "img/logo-icon-8.21de7370.png";